<template>
  <div class="range-slider">
    <p class="mb-0">
      Scale
      <span class="pull-right">{{ scale }}</span>
    </p>

    <input
      v-model="scale"
      class="range-slider__range"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :style="{ width:width +'px'}"
      />
  </div>

</template>

<script>
export default {
  name: 'avatarScale',
  props: {
    width: {
      type: Number,
      default: 200
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 2
    },
    step: {
      type: Number,
      default: 0.01
    }
  },
  data () {
    return {
      scale: 1
    }
  },
  watch: {
    scale () {
      this.$emit('avatar:change-scale', this.scale)
    }
  },
  methods: {
    setScale (scale) {
      this.scale = scale
    }
  }
}
</script>
